import { researchPlatformListingSection } from '@stereoagency/sanity-schema';
import { $globalSanityClient } from '@/sanity';
import { researchPlatformsQuery } from './researchPlatformsQuery';
import UIResearchPlatformListingSection from './ResearchPlatformListingSection.client';
import { actionAsProps } from '@/utils';

type Props =
  typeof researchPlatformListingSection.schema.researchPlatformListingSection;

export default async function ResearchGroupListingSection({
  title,
  subtitle,
  action,
  enableTaxonomyFilter,
  staticFilter,
  hideCardImages
}: Props) {
  const data = await $globalSanityClient.fetch<
    (typeof researchPlatformsQuery)[1]
  >(researchPlatformsQuery[0], {
    taxonomies: !enableTaxonomyFilter
      ? staticFilter?.map((tax) => tax._ref) ?? []
      : []
  });

  return (
    <UIResearchPlatformListingSection
      title={title}
      subtitle={subtitle}
      action={action ? actionAsProps(action) : undefined}
      enableTaxonomyFilter={enableTaxonomyFilter}
      hideCardImages={hideCardImages}
      platforms={data}
    />
  );
}
